module.exports = __webpack_public_path__ + "static/media/S2N2-1.786aac2e.svg";